<template>
  <div :class="classes()">
    <select
      :class="`${el}__input`"
      v-on="{ ...$listeners, input: (event) => $emit('input', event.target.value) }"
    >
      <option
        v-for="item in items"
        :value="item.value"
        :selected="item.selected || selected(item.value)"
        :disabled="item.disabled"
        v-bind:key="item.value"
      >
        {{ item.label }}
      </option>
    </select>
    <Copy
      v-if="error"
      element="div"
      size="s"
      :staticClass="`${el}__helperText`"
      color="supportDanger"
    >
      {{ error }}
    </Copy>
  </div>
</template>

<script>
import Copy from '@/objects/Copy/Copy';
export default {
  name: 'BaseSelect',
  components: { Copy },
  props: {
    items: {
      label: [String, Number],
      value: [String, Number],
      selected: [Boolean],
      disabled: [Boolean],
    },
    activeValue: [String, Number],
    expand: Boolean,
    light: Boolean,
    error: {
      type: [String, Boolean],
      default: false,
    },
  },
  methods: {
    selected(value) {
      return this.activeValue && value === this.activeValue;
    },
  },
  data() {
    return {
      el: 'o-baseSelect',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--expand`]: this.expand,
          [`${el}--light`]: this.light,
        };
      },
    };
  },
};
</script>
